import CircularProgress from '@material-ui/core/CircularProgress'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core/styles'
import BlockIcon from '@material-ui/icons/Block'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import MoneyIcon from '@material-ui/icons/LocalAtm'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { h24InventoryAvailability, h24PushYearPrices, h24PushYearRestrictions } from '../../../../../api/h24Api/h24Sync'
import { selectCurrentOrganization } from '../../../../../selectors/hotels24Selectors/h24CurrentOrganization'

const styles = theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        width: '95%'
    },
    progress: {
        margin: theme.spacing.unit * 2
    }
})

class SyncTab extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        h24PushYearPrices: PropTypes.func,
        h24PushYearRestrictions: PropTypes.func,
        h24InventoryAvailability: PropTypes.func,
        pendingPushYearPrices: PropTypes.bool,
        pendingPushYearRestrictions: PropTypes.bool,
        pendingInventoryAvailability: PropTypes.bool,
        organizationId: PropTypes.number.isRequired
    }

    handlePushYearPrices = () => this.props.h24PushYearPrices({ organizationIds: [this.props.organizationId] })
    handlePushYearRestrictions = () =>
        this.props.h24PushYearRestrictions({ organizationIds: [this.props.organizationId] })
    handleInventoryAvailability = () =>
        this.props.h24InventoryAvailability({ organizationId: this.props.organizationId })

    render() {
        const { classes, pendingPushYearPrices, pendingPushYearRestrictions, pendingInventoryAvailability } = this.props
        return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <List>
                        <ListItem button onClick={this.handlePushYearPrices} disabled={pendingPushYearPrices}>
                            <ListItemIcon>
                                <MoneyIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить цены"
                                secondary="Это действие отправляет цены в Hotels24.ua на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearPrices && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem
                            button
                            onClick={this.handlePushYearRestrictions}
                            disabled={pendingPushYearRestrictions}
                        >
                            <ListItemIcon>
                                <BlockIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Отправить ограничения"
                                secondary="Это действие отправляет ограничения в Hotels24.ua на 1 год вперёд"
                            />
                            <ListItemSecondaryAction>
                                {pendingPushYearRestrictions && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                        <ListItem
                            button
                            onClick={this.handleInventoryAvailability}
                            disabled={pendingInventoryAvailability}
                        >
                            <ListItemIcon>
                                <EventAvailableIcon />
                            </ListItemIcon>
                            <ListItemText
                                primary="Inventory доступности"
                                secondary="Это действие сравнивает доступность в Hotels24.ua с доступностью в EasyMS. Если доступность в EasyMS отличается, то она будет пересчитана и отправлена в Hotels24.ua"
                            />
                            <ListItemSecondaryAction>
                                {pendingInventoryAvailability && <CircularProgress className={classes.progress} />}
                            </ListItemSecondaryAction>
                        </ListItem>
                    </List>
                </Paper>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    organizationId: selectCurrentOrganization(state),
    pendingPushYearPrices: state.h24Sync.pendingPushYearPrices,
    pendingPushYearRestrictions: state.h24Sync.pendingPushYearRestrictions,
    pendingInventoryAvailability: state.h24Sync.pendingInventoryAvailability
})

export default connect(
    mapStateToProps,
    {
        h24PushYearPrices,
        h24PushYearRestrictions,
        h24InventoryAvailability
    }
)(withStyles(styles)(SyncTab))



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/MappingTabs/SyncTab/SyncTab.js